export default "__VITE_ASSET__CoGrZu58__"